module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres35u"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres35uIndex,
      "searchBoxAlias": "approve",
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.approveEvent,
      "approveRowBool": true
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "labels": _vm.labels[_vm.dash.nowLang],
      "detail": _vm.detail,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group-button"
  }, [_c('button', {
    ref: "approve",
    staticClass: "btn bg-blue",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#hres35u-popup-approve"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.btn_approve))])]), _vm._v(" "), _c('popup-approve', {
    attrs: {
      "labels": _vm.labels[_vm.dash.nowLang],
      "nowLang": _vm.dash.nowLang,
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "indexSelected": _vm.indexSelected,
      "arrCodmov": _vm.dropdowns.codmov,
      "postHres35uSendApprove": _vm.postHres35uSendApprove,
      "codappr": _vm.codempid,
      "descCodappr": _vm.dash.currentUser.username[_vm.dash.nowLang]
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71edb762!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres35u/component.vue
// module id = 3862
// module chunks = 1